/**
 * Blog consolidation: near-duplicate posts merged into one post per topic.
 *
 * Keys are retired post slugs, values are the post they 301 to. A retired
 * post that still exists in Prismic is not built, so it drops out of the
 * sitemap, llms.txt and the blog listing. Slugs already deleted from Prismic
 * are listed too, so their old URLs redirect instead of returning 404.
 *
 * To merge another duplicate, add it here. To bring a post back, remove it.
 * Never point a slug at another retired slug.
 */

const BLOG_REDIRECTS = {
  // Coffee shop / café POS (UK)
  "best-pos-system-independent-cafes-uk": "best-pos-systems-coffee-shops-uk",
  "best-pos-systems-independent-cafes-uk": "best-pos-systems-coffee-shops-uk",
  "pos-system-independent-cafe-uk": "best-pos-systems-coffee-shops-uk",
  "pos-systems-independent-cafes-uk": "best-pos-systems-coffee-shops-uk",
  "best-coffee-shop-epos-system-uk": "best-pos-systems-coffee-shops-uk", // deleted
  "best-epos-system-coffee-shops-uk": "best-pos-systems-coffee-shops-uk", // deleted
  "best-epos-systems-uk-coffee-shops": "best-pos-systems-coffee-shops-uk", // deleted
  "best-pos-coffee-shops-uk": "best-pos-systems-coffee-shops-uk", // deleted
  "best-pos-for-coffee-shops-uk": "best-pos-systems-coffee-shops-uk", // deleted
  "coffee-shop-epos-system-uk": "best-pos-systems-coffee-shops-uk", // deleted

  // Commission-free ordering for coffee shops
  "boost-coffee-shop-grubpos-commission-free": "commission-free-ordering-coffee-shops",
  "coffee-shop-commission-free-ordering": "commission-free-ordering-coffee-shops", // deleted
  "grubpos-coffee-shop-commission-free-ordering": "commission-free-ordering-coffee-shops", // deleted
  "grubpos-commission-free-ordering-coffee-shops": "commission-free-ordering-coffee-shops", // deleted

  // Best EPOS system for UK restaurants
  "best-epos-system-independent-restaurants-uk": "best-epos-system-restaurants-uk",
  "best-epos-systems-independent-restaurants-uk": "best-epos-system-restaurants-uk",
  "epos-system-for-restaurants-uk": "best-epos-system-restaurants-uk",
  "epos-system-restaurant-uk": "best-epos-system-restaurants-uk",
  "epos-system-restaurants-uk": "best-epos-system-restaurants-uk",
  "epos-systems-restaurants-uk": "best-epos-system-restaurants-uk",

  // EPOS systems for UAE restaurants
  "epos-system-for-restaurants-uae": "epos-system-restaurants-uae",
  "epos-systems-restaurant-uae": "epos-system-restaurants-uae",
  "epos-systems-restaurants-uae": "epos-system-restaurants-uae",
  "epos-systems-uae-restaurants": "epos-system-restaurants-uae",

  // Cloud-based POS
  "boost-efficiency-with-cloud-based-pos-systems": "boost-restaurant-efficiency-cloud-pos",
  "cloud-based-epos-qsr-uk": "cloud-based-epos-for-qsr-uk",

  // Commission-free delivery platforms for UK takeaways
  "commission-free-delivery-takeaways-uk": "commission-free-delivery-platform-uk",
  "commission-free-delivery-platform-takeaways-uk": "commission-free-delivery-platform-uk", // deleted
  "commission-free-delivery-solutions-uk-takeaways": "commission-free-delivery-platform-uk", // deleted

  // Cutting delivery app costs (UK restaurants)
  "cut-costs-food-delivery-apps-uk-restaurants": "cut-food-delivery-costs-uk-restaurants",
  "save-money-food-delivery-apps-uk-restaurant": "cut-food-delivery-costs-uk-restaurants",
  "save-money-food-delivery-apps-uk-restaurants": "cut-food-delivery-costs-uk-restaurants",
  "cut-delivery-app-costs-uk-takeaways": "cut-food-delivery-costs-uk-restaurants", // deleted

  // Stop paying delivery app commission (UK takeaways)
  "stop-paying-delivery-app-commission-uk-takeaway": "stop-paying-delivery-app-commissions-uk-takeaway",

  // Taking online orders without commission
  "take-online-orders-without-commission": "take-online-orders-without-paying-commission",
  "commission-free-online-ordering-restaurants": "take-online-orders-without-paying-commission", // deleted
  "commission-free-online-ordering-solutions": "take-online-orders-without-paying-commission", // deleted
  "master-commission-free-online-orders": "take-online-orders-without-paying-commission", // deleted

  // Direct ordering systems (UK)
  "boost-restaurant-sales-direct-ordering-uk": "direct-ordering-system-uk-restaurants",
  "restaurant-direct-ordering-system-uk": "direct-ordering-system-uk-restaurants",

  // Own website ordering vs Deliveroo
  "restaurant-own-website-ordering-vs-deliveroo": "own-website-ordering-vs-deliveroo",
  "restaurant-website-ordering-vs-deliveroo": "own-website-ordering-vs-deliveroo",

  // Deliveroo commission
  "reduce-deliveroo-commissions": "reduce-deliveroo-commission",
  "cutting-deliveroo-costs-guide": "reduce-deliveroo-commission",

  // Just Eat commission
  "cutting-just-eat-commissions": "reduce-just-eat-commissions",
  "reduce-just-eat-commission-restaurants": "reduce-just-eat-commissions",

  // Uber Eats alternatives
  "alternatives-uber-eats-uk-restaurants": "uber-eats-alternatives-uk-restaurants",
  "uber-eats-commission-alternatives-uk": "uber-eats-alternatives-uk-restaurants",
  "uber-eats-commission-alternatives-uk-restaurants": "uber-eats-alternatives-uk-restaurants",

  // Exact duplicate
  "enhancing-efficiency-and-service-quality-with-seamless-app":
    "enhancing-efficiency-and-service-quality-with-seamless-app-integration",
}

const isRetiredBlog = uid => Boolean(uid && BLOG_REDIRECTS[uid])

module.exports = { BLOG_REDIRECTS, isRetiredBlog }
